<template>
  <section
    id="hero"
    class="ml-6 mr-6"
  >
    <!--
    :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.JPG`)"
        :aspect-ratio="4/3"
    -->
    <v-container class="grey lighten-5">
      <span class="trace">Neighborhood.vue</span>

      <v-row>
        <v-col
          md="10"
          offset-md="1"
        >
          <h3>Compromising Our Drinking Water</h3>
          <p class="mt-2">
            While we may not realize it, we could be compromising our friendly neighbors’ health, and they could unintentionally be affecting ours. We are now seeing the presence of a wide range  of chemicals, solvents, cleaning products, pharmaceuticals, that we use daily, and have accidentally tossed down our drains, used in our gardens or on our lawns, in our precious Truro drinking water. Yes!
          </p>
          <!--
          <v-img
            :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.jpg`)"
            max-width=800
            class="mx-10"
          >
          </v-img>
          -->
          <p class="mt-2">
            Unfortunately, our septic systems were not designed to neutralize or dispose of these harsh and often toxic chemicals. The reality is that these chemicals trickle down to taint Truro’s water table, the Pamet lens, which is our community-shared drinkable water source.  And, what’s even more troubling is that as our outdated septic systems age, and begin to crumble, with the advent of climate change and ever-rising tides, often placed too near private wells, there is the very real risk of both chemical pollutants and salinity contaminating our drinking water. This is a lot to think about!
          </p>
          <p class="mt-2">
            While conventional Truro town well water tests mean well, the criteria for evaluating the levels of carcinogenic substances have unfortunately not kept up with the rising levels of toxicity. The EPA has set allowances for toxic substances in water in general at a standard that is at a bare minimum, to what in their books is considered legal, not to what is actually believed to be healthy for our community. We might ask, why should public safety standards be different whether we are talking about well water or public Water? Should it not be that no drinkable water anywhere should be tainted?  As private well owners, it is our responsibility to keep our water standard high, making sure that our water source remains clean and healthy. Please find more detailed information on the <a
              href="https://silentspring.org/"
              target="_blank"
            >Silent Spring Institute of Newton*</a>,  which has been analyzing water from Cape Cod’s private wells for over 20 years.
          </p>
          <p class="mt-2">
            Given that we may all be drinking the same water, we want to rest assured that this water is safe and healthy for everyone in Truro.**
          </p>
          <p class="mt-2">
            The Environmental Work Group's health guidelines and <a
              href="https://www.ewg.org/tapwater/ewg-standards.php"
              target="_town"
            > standards for drinking water contaminants</a> fill the gap in outdated government standards.  The federal government’s legal limits are not health-protective. The EPA has not set a new tap water standard in almost 20 years, and some standards are more than 40 years old.
            <a
              href="https://www.ewg.org/tapwater/system.php?pws=MA4242000"
              target="_town"
            >EWG's drinking water quality report</a> for Provincetown is relevant.  This water is pumped from Truro, and then treated.
          </p>

          <h4>More Information Coming Soon</h4>
          <p class="mt-2">
            Please bear with us as our Water Protector volunteers work to flesh out the details of this program.  We have more worthy programs than volunteer hours, so it takes a little time to get a new program up and going.  So please stay tuned.
          </p>
          <p class="mt-2">
            Thus our mission, as the Truro Water protectors, is to clean up our water table to prevent further health issues. Both clean water and clean air, we can all agree, go hand in hand.
          </p>

          <h4>TOGETHER WE CAN STOP THE POLLUTION AND START PROTECTING OUR TRURO WATER.</h4>
          <p class="mt-2">
            In the following weeks, we will be offering simple suggestions, that if we all participate in, will begin to help clean up some of our water issues. We would love your input and suggestions as we go along. <!--Please check out our website, Climateactiontruro.org, where we will go more deeply into our drinking Water issues.-->
          </p>
          <div v-if="1==0">
            <!-- fix N Truro and sync with Transparent Truro -->
            <h4>N. TRURO WATER FRAGILITY</h4>
            <p class="mt-2">
              North Truro in particular has issues with the quality of water, especially in the Pond Village neighborhood which is at a low point in the water table in N Truro.  This two minute video clip from a recent
              <a
                href="http://trurotv.truro-ma.gov/CablecastPublicSite/gallery/2?channel=1"
                target="_town"
              >Zoning Board of Appeals hearing</a> on July 25, 2020, where ZBA members ask question of the Town Planner, underscores these concerns.
            </p>

            <iframe
              src="https://player.vimeo.com/video/443836589?texttrack=en-US&loop=0&autopause=1"
              width="640"
              height="387"
              frameborder="0"
              allowfullscreen
              allow="autoplay; fullscreen"
            />

            <p class="mx-6">
              <b>ZBA member John Thornley</b>: “I’m still concerned about the discharge of water into the neighbors’ area.  In the past we have always vowed that all the projects we worked on would not be detrimental to the neighborhood.  This has the potential to be quite detrimental to the neighborhood.   I’m really worried that we are going topass this on and then later on have a disaster.”
            </p>
            <p class="mx-6">
              <b>Town Planner Jeff Ribeiro</b>: “To some degree if areas down gradient are already impaired, I think that probably a lot of N Truro should be on public drinking water supply with or without the Cloverleaf based on development patterns.  When you have lots as small as N Truro has I don’t think that septic plus well works.  I wouldn’t want to live over there.”
            </p>
          </div>
          <!--

<iframe src="https://player.vimeo.com/video/443836589" width="640" height="387" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>

            allow="autoplay; fullscreen"

        -->
        </v-col>
      </v-row>

      <v-row>
        <v-col
          md="10"
          offset-md="1"
        >
          <v-btn
            small
            class="mr-0 small"
            @click="wpClick"
          >
            Back to Water Protectors<span class="hidden-md-and-down">...</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          md="10"
          offset-md="1"
        >
          <div v-if="youTube">
            <hr>
            <p class="mt-2">
              * The Silent Spring Institute of Newton has been analyzing water from Cape Cod’s private wells for over 20 years. Where they differ from standard EPA guidelines for safe water is that, for example, they consider that when testing for a nitrates, anything below 10 ppm (10 mg/liter) is considered safe, while the Silent Spring maintains that nitrate levels should not exceed 1 ppm. Their water analyses show that even at 1 ppm they are finding known carcinogenic substances in the water such as glyphosate, PFOS, PFOA, MTBE, just to name a few!  Both water specialists and filter company Culligan, and the Silent Spring Institute have found contaminants in water tested upon request from Truro residents.
            </p>
            <p class="mt-2">
              **In an article, titled <em>Cape Cod is a hot spot for certain types of cancers</em>, posted on 28 November, 2017, journalist Joyce R.  Young reports, “For the last 20 years, the Silent Spring Institute of Newton has been investigating one of Cape Cod’s dark sides: high rates of breast cancer.  At its annual Cape Cod update presentation in October 2017, the institute shared more research data on what are known as contaminants of emerging concern emanating from the Cape’s septic systems and cesspools in relation to the high breast cancer rates.”
            </p>

            <!--
            <p class="mt-2">
            ** Here's a slightly technical YouTube video <a
            href="https://www.youtube.com/watch?v=2zgC8xED3_M"
            target="_blank"
            >What is a Reverse Osmosis Tank and How Does it Work?</a>
            </p>
            -->
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          md="10"
          offset-md="1"
        >
          <v-btn
            small
            class="mr-0 small"
            @click="wpClick"
          >
            Back to Water Protectors<span class="hidden-md-and-down">...</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="1==0">
        <v-btn
          small
          class="mr-2 small"
          @click="zbaClick"
        >
          ZBA letter<span class="hidden-md-and-down">...</span>
        </v-btn>
      </v-row>
      <v-row v-if="1==0">
        <v-btn
          small
          class="mr-2 small"
          @click="neighborhoodClick"
        >
          Nieghborhood<span class="hidden-md-and-down">...</span>
        </v-btn>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: 'Adapt',

    components: {
      // ToolbarWq: () => import('@/views/projects/ToolbarWq'),
    },

    data: () => ({
      // maxW: 800,
      youTube: true,
    }),

    methods: {
      wpClick: function (event) {
        this.$router.push({ name: 'splashWQ' })
      },
      zbaClick: function (event) {
        this.$router.push({ name: 'PondVillage' })
      },
      neighborhoodClick: function (event) {
        this.$router.push({ name: 'Neighborhood' })
      },
    },

  }
</script>
